module.exports = __webpack_public_path__ + "img/2ab10bd.jpg";